import edu from "./education/ar";
import lib from "./library/ar";
import al from "./assets/ar";
import vm from "./videoMoments/ar";
import iv from "./interview/ar";
import lvl from "./level/ar";
import pm from "./practice/ar";
// Phase 5.3 — Arabic (العربية) — RTL interface locale.
const ar = {
  footer: { forSchools: "للمدارس", tagline: "حياتك تصبح دورتك اللغوية.", eu: "مصمَّم للاتحاد الأوروبي 🇪🇺 · الامتثال للائحة GDPR أولًا · لا نحتفظ أبدًا بصورك أو صوتك.", product: "المنتج", signIn: "تسجيل الدخول", getStarted: "ابدأ الآن", legal: "قانوني", privacy: "سياسة الخصوصية", terms: "شروط الخدمة" },
  cookie: { title: "نحن نهتم بخصوصيتك 🍪", body: "يستخدم GetFluentLoop ملفات تعريف الارتباط الأساسية لإبقائك مسجّلًا للدخول. لا نبيع بياناتك أبدًا، ولا نحتفظ أبدًا بصورك أو تسجيلاتك الصوتية الأصلية. اطّلع على", link: "سياسة الخصوصية", end: ".", accept: "قبول", decline: "رفض" },
  cefr: {"A1": "أعرف بعض الكلمات", "A2": "عبارات يومية بسيطة", "B1": "أستطيع إجراء محادثة بسيطة", "B2": "أتحدّث بطلاقة إلى حدٍّ ما", "C1": "أشعر براحة كبيرة", "C2": "قريب من مستوى الناطقين"},
  landing: { imgAlt: "متعلّم", streakBadge: {"zero": "{count} أيام متتالية!", "one": "{count} يوم متتالٍ!", "two": "يومان متتاليان!", "few": "{count} أيام متتالية!", "many": "{count} يومًا متتاليًا!", "other": "{count} يوم متتالٍ!"}, heroSub: "تعلّم مما تراه وتفكّر فيه وتقوله وتقرؤه وتعيشه — بينما يكيّف GetFluentLoop اللغة حول حياتك الحقيقية. ابدأ مجانًا في ثوانٍ.","freeTag": "مجاني", "featJournal": "المذكّرة الصوتية", "featToday": "اليوم الذكي", "descLoop": "رأيت شيئًا؟ التقط صورته وتعلّم الكلمة فورًا.", "descFriend": "يخطر لك شيء؟ قُله بشكل طبيعي — تحدّث عن حياتك باللغة التي تتعلّمها.", "descLens": "اقرأ اللافتات وقوائم الطعام والأشياء والمشاهد من حولك — وتعلّم منها.", "descJournal": "تحدّث عن يومك أو اكتبه بكلماتك. واسمعه بشكل طبيعي بلغتك الجديدة.", "descToday": "عُد غدًا: يبني دماغ التعلّم درسك القصير التالي حول ما يهمّك.", "mockLearned": "ما تعلّمته اليوم", "mockGloss": "الشجرة طويلة جدًا."},
  dash: { freezeSaved: {"zero": "🛡️ حمى تجميد السلسلة سلسلتك!", "one": "🛡️ حمى تجميد السلسلة سلسلتك ليوم واحد!", "two": "🛡️ حمى تجميد السلسلة سلسلتك ليومين!", "few": "🛡️ حمى تجميد السلسلة سلسلتك لـ{count} أيام!", "many": "🛡️ حمى تجميد السلسلة سلسلتك لـ{count} يومًا!", "other": "🛡️ حمى تجميد السلسلة سلسلتك لـ{count} يوم!"},"hey": "مرحبًا {name} 👋", "heyAnon": "مرحبًا 👋", "learning": "تتعلّم {lang} · المستوى {level}", "recap": "ملخّص الأسبوع", "upgrade": "الترقية إلى Pro", "todayLoop": "جولة اليوم", "todayLoopSub": "جلستك المخصّصة لمدة 5 دقائق — ابدأ الآن", "classAssignments": "مهام الصف", "viewAll": "عرض الكل ←", "continue": "متابعة", "start": "ابدأ", "allCaught": "أنجزت كل شيء — أحسنت! 🎉", "momentum": "زخمك", "freezeHelp": "تحمي تجميدات السلسلة سلسلتك إذا فاتك يوم", "freezes": {"zero": "لا تجميدات", "one": "تجميد واحد", "two": "تجميدان", "few": "{count} تجميدات", "many": "{count} تجميدًا", "other": "{count} تجميد"}, "streakCalendar": "عرض تقويم السلسلة ←", "totalXp": "إجمالي نقاط الخبرة", "wordsLearned": "كلمات تعلّمتها", "dueForReview": "مستحقّة للمراجعة ←", "captures": "لقطات", "conversations": "محادثات", "accentTrend": "تطوّر النطق", "noScores": "لا توجد نتائج بعد — جرّب", "noScoresEnd": ".", "recent": "النشاط الأخير", "nothingYet": "لا شيء بعد. ابدأ الالتقاط!", "jumpBack": "تابع من حيث توقّفت"},
  nudge: {"streakTitle": {"zero": "حافظ على سلسلتك!", "one": "حافظ على سلسلتك ليوم واحد!", "two": "حافظ على سلسلتك ليومين!", "few": "حافظ على سلسلتك لـ{count} أيام!", "many": "حافظ على سلسلتك لـ{count} يومًا!", "other": "حافظ على سلسلتك لـ{count} يوم!"}, "streakSub": "أكمل جولة اليوم حتى لا تخسرها.", "startLoop": "ابدأ الجولة", "dueTitle": {"zero": "لا توجد كلمات مستحقّة للمراجعة", "one": "كلمة واحدة مستحقّة للمراجعة", "two": "كلمتان مستحقّتان للمراجعة", "few": "{count} كلمات مستحقّة للمراجعة", "many": "{count} كلمةً مستحقّة للمراجعة", "other": "{count} كلمة مستحقّة للمراجعة"}, "dueSub": "جولة من دقيقتين تُبقيها في ذاكرتك طويلة المدى.", "reviewNow": "راجع الآن"},
  tour: {"t1": "مرحبًا بك في GetFluentLoop! 🎉", "b1": "تطبيق واحد يحوّل حياتك اليومية إلى دورتك اللغوية — كل ميزة تغذّي بنك مفردات واحدًا مشتركًا.", "t2": "وجّه الكاميرا", "b2": "يحوّل LanguageLoop أي شيء حولك إلى كلمة: التقط صورة واحصل على الكلمة وجملة ونطقها.", "t3": "تدرّب فعلًا", "b3": "تحدّث مع Roommate بالذكاء الاصطناعي، وقيّم نطقك، وناقش موضوعًا، واختبر نفسك في كلماتك.", "t4": "جولة اليوم", "b4": "لا تعرف من أين تبدأ؟ اضغط على جولة اليوم لجلسة مخصّصة لمدة 5 دقائق كل يوم.", "t5": "ابنِ سلسلة", "b5": "تدرّب يوميًا لتنمو سلسلتك — واجمع تجميدات السلسلة حتى لا يكسرها يوم مزدحم.", "back": "رجوع", "next": "التالي", "start": "ابدأ التعلّم", "skip": "تخطَّ الجولة"},
  vocabSrc: {"manual": "أضفتها بنفسك", "mission": "مهمة", "word_explorer": "مستكشف الكلمات", "object_lens": "FluentLens · شيء", "scene_lens": "FluentLens · مشهد", "text_lens": "FluentLens · نص", "fluent_friend_live": "الصديق المباشر"},
  common: {
    save: "حفظ", cancel: "إلغاء", add: "إضافة", addSelected: "إضافة المحدد",
    addAll: "إضافة الكلمات المفيدة", delete: "حذف", edit: "تعديل", retake: "إعادة التصوير",
    scanAgain: "مسح مرة أخرى", continue: "متابعة", back: "رجوع", next: "التالي",
    close: "إغلاق", loading: "جارٍ التحميل…", search: "بحث", logout: "تسجيل الخروج",
    settings: "الإعدادات", listen: "استماع", stop: "إيقاف", added: "تمت الإضافة",
  },
  nav: {
    educationadmin: "إدارة التعليم",
    more: "المزيد",
    dashboard: "لوحة التحكم", today: "اليوم", languageloop: "LanguageLoop",
    fluentlens: "FluentLens", roommate: "Roommate", accentcoach: "AccentCoach",
    debategym: "DebateGym", quizforge: "QuizForge", story: "قصة",
    "vocab bank": "بنك المفردات", "discovery lab": "Discovery Lab", assignments: "المهام", myclasses: "صفوفي", teacher: "المعلّم", journal: "المذكّرة", friend: "صديق",
  },
  auth: { welcomeBack: "مرحبًا بعودتك!", welcomeNew: "مرحبًا بك في GetFluentLoop! 🎉",
    signInTitle: "مرحبًا بعودتك", signUpTitle: "أنشئ حسابك",
    signInSub: "سجّل الدخول لمواصلة التعلّم.", signUpSub: "ابدأ التعلّم في أقل من دقيقة.",
    continueWithGoogle: "المتابعة باستخدام Google", or: "أو", yourName: "اسمك",
    email: "البريد الإلكتروني", password: "كلمة المرور", iSpeak: "أنا أتحدث", imLearning: "أنا أتعلّم",
    myLevel: "مستواي", createAccount: "إنشاء حساب", signIn: "تسجيل الدخول",
    acceptTerms: "أوافق على الشروط وسياسة الخصوصية.",
    haveAccount: "لديك حساب بالفعل؟", noAccount: "جديد هنا؟",
  },
  onboarding: {
    allSet: "كل شيء جاهز! 🎉",
    welcome: "مرحبًا بك في GetFluentLoop", title: "لنُجهّز حسابك",
    subtitle: "أخبرنا بما تتعلّمه.", iSpeak: "أنا أتحدث",
    imLearning: "أنا أتعلّم", level: "المستوى", finish: "ابدأ التعلّم",
    allSet: "كل شيء جاهز! 🎉",
  },
  settings: {
    title: "الإعدادات", interfaceLanguage: "لغة الواجهة",
    interfaceLanguageHelp: "لغة القوائم والأزرار والرسائل. هذا لا يغيّر ما تتعلّمه.",
    learning: "لغة التعلّم", native: "اللغة الأم", level: "المستوى",
    learningProfiles: "ملفات التعلّم",
    learningProfilesHelp: "احتفظ بعدة لغات في حساب واحد. تبديل الملف يغيّر سياق التعلّم الشخصي فقط — حسابك ودورك ومدارسك تبقى كما هي.",
    addProfile: "إضافة ملف لغة", switch: "تبديل", active: "نشط",
    createAndSwitch: "إنشاء وتبديل", nameOptional: "الاسم (اختياري)",
    pickDifferent: "اختر لغتين مختلفتين للتحدّث والتعلّم.",
    profileSwitched: "تم تبديل ملف التعلّم",
  },
  lens: {
    home: "FluentLens", tagline: "وجّه كاميرتك نحو العالم وتعلّم اللغة من حولك.",
    textLens: "عدسة النص", objectLens: "عدسة الأشياء", studyLens: "عدسة الدراسة",
    sceneLens: "عدسة المشهد", takePhoto: "التقاط صورة", uploadImage: "رفع صورة",
    translate: "ترجمة", explain: "شرح", quizMe: "اختبرني", describe: "وصف",
    identifyCount: "التعرّف والعدّ", learnVocab: "تعلّم المفردات",
    saveScan: "حفظ في الأرشيف", archive: "الأرشيف", usefulVocab: "مفردات مفيدة",
    naturalTranslation: "ترجمة طبيعية", gist: "الفكرة العامة", check: "تحقّق",
    addWord: "إضافة الكلمة", addRelated: "إضافة الكلمات ذات الصلة", wordsAround: "كلمات ذات صلة",
    whereThings: "أين توجد الأشياء", suggestedAnswer: "إجابة مقترحة",
  },
  mission: {
    speak: "تحدّث", type: "اكتب", startRecording: "اضغط للتحدّث", stop: "إيقاف",
    retry: "إعادة المحاولة", usefulPhrases: "عبارات مفيدة", wordsToRemember: "كلمات لتتذكّرها",
    completeMission: "إكمال المهمة", nextStep: "الخطوة التالية", recap: "ملخّص التعلّم",
    showRecap: "عرض", hideRecap: "إخفاء", typeFirst: "اكتب ردّك الأول للبدء.",
    speakFirst: "اضغط على الميكروفون وقل جملتك الأولى للبدء.",
    typeReply: "اكتب ردّك…",
  },
  home: {
    badge: "🇪🇺 صُنع في الاتحاد الأوروبي · الخصوصية أولًا · عالمي بالتصميم",
    heroPre: "حياتك تصبح", heroPost: "دورتك في", heroWord: "اللغة",
    getStarted: "ابدأ الآن", signIn: "تسجيل الدخول", dashboard: "لوحة التحكم",
    tryFree: "جرّب LanguageLoop مجانًا", startLearning: "ابدأ التعلّم",
    privacy: "لا يتم تخزين أي صورة أو تسجيل على الإطلاق.",
    bundlesTitle: "كل شيء يغذّي حلقة تعلّم واحدة.",
    bundlesSub: "اكتشف كلمة في أي مكان، ثم استكشفها وتذكّرها. كل ميزة تشارك بنك مفردات واحدًا وذاكرة لما تعرفه وخطة يومية هادئة.",
    priceSub: "كل شيء مشمول. يمكنك الإلغاء في أي وقت.", startNow: "ابدأ الآن",
  },
  pilot: {
    daysRemaining: {
      zero: "لم يتبقَّ أي يوم", one: "يتبقّى يوم واحد", two: "يتبقّى يومان",
      few: "تتبقّى {count} أيام", many: "يتبقّى {count} يومًا", other: "يتبقّى {count} يوم",
    },
  },
  today: { dueSoon: "تستحقّ قريبًا", overdue: "متأخّرة", continueMission: "تابع مهمة صفّك", yourMission: "مهمة صفّك", minutes: {"zero": "~{count} دقيقة", "one": "~دقيقة واحدة", "two": "~دقيقتان", "few": "~{count} دقائق", "many": "~{count} دقيقة", "other": "~{count} دقيقة"}, stepsProgress: "{done}/{total} خطوات", wordProgress: "الكلمة {n} من {total}", unlockPro: "افتح مع Pro", skipForNow: "تخطَّ الآن", weHeard: "سمعنا:", skip: "تخطَّ", snapHint: "التقط صورة لأي شيء حولك لإضافة كلمة جديدة إلى بنكك.", doLater: "سأفعل ذلك لاحقًا", bonusXp: {"zero": "⁦+{count}⁩ نقطة خبرة إضافية", "one": "⁦+{count}⁩ نقطة خبرة إضافية", "two": "⁦+{count}⁩ نقطتا خبرة إضافيتان", "few": "⁦+{count}⁩ نقاط خبرة إضافية", "many": "⁦+{count}⁩ نقطة خبرة إضافية", "other": "⁦+{count}⁩ نقطة خبرة إضافية"}, micUnavailable: "الميكروفون غير متاح.", scoringFailed: "تعذّر التقييم.", paywallReason: "تقييم النطق جزء من GetFluentLoop Pro.",
    title: "جلسة اليوم", subtitle: "جلستك الشخصية في 5 دقائق.",
    dayStreak: { zero: "أيام متتالية", one: "يوم متتالٍ", two: "يومان متتاليان", few: "أيام متتالية", many: "يومًا متتاليًا", other: "يوم متتالٍ" }, streakText: {"zero": "{count} أيام متتالية", "one": "{count} يوم متتالٍ", "two": "يومان متتاليان", "few": "{count} أيام متتالية", "many": "{count} يومًا متتاليًا", "other": "{count} يوم متتالٍ"}, startLoop: "ابدأ جلسة اليوم", reveal: "أظهر الإجابة",
    gotIt: "عرفتها", missedIt: "أخطأت", sayItOut: "قلها بصوتٍ عالٍ", hearIt: "استماع",
    skip: "تخطّي", continue: "متابعة", loopComplete: "اكتملت الجلسة!",
    loopCompleteToday: "اكتملت جلسة اليوم!", comeBack: "عُد غدًا.",
    backToDashboard: "العودة إلى لوحة التحكم", word: "كلمة", reviewWords: "مراجعة الكلمات",
    saySentence: "قل جملة", captureNew: "التقط شيئًا جديدًا",
    openCamera: "فتح الكاميرا", learnNewWord: "تعلّم كلمة جديدة", practiceAgain: "تدرّب مرة أخرى",
  },
  wordExplorer: {
    script: "الأبجدية",
    scriptSaved: "تم حفظ تفضيل الأبجدية",
    pos: {
      noun: "اسم",
      verb: "فعل",
      adjective: "صفة",
      adverb: "ظرف",
      pronoun: "ضمير",
      preposition: "حرف جر",
      conjunction: "حرف عطف",
      phrase: "عبارة",
      other: "أخرى",
      related: "ذات صلة",
    },
    labels: {
      present: "المضارع",
      past_compose: "الماضي (passé composé)",
      past_preterite: "الماضي (pretérito)",
      imperfect: "الماضي الناقص",
      future: "المستقبل",
      conditional: "الشرطي",
      subjunctive: "صيغة الاحتمال",
      singular: "المفرد",
      plural: "الجمع",
      nominative: "حالة الرفع",
      genitive: "حالة الإضافة",
      dative: "حالة القابل",
      accusative: "حالة النصب",
      instrumental: "حالة الأداة",
      prepositional: "حالة الجر بحرف",
      present_imperfective: "المضارع (غير تام)",
      future_perfective: "المستقبل (تام)",
      past: "الماضي",
      imperative: "الأمر",
      forms: "الصيغ",
      masculine: "مذكر",
      feminine: "مؤنث",
      neuter: "محايد",
      short_m: "مختصرة م.",
      short_f: "مختصرة م.ث.",
      short_forms: "الصيغ المختصرة",
    },
    explore: "استكشاف",
    exploreWord: "استكشف «{word}»",
    title: "مستكشف الكلمات",
    howChanges: "كيف تتغير هذه الكلمة",
    seeMoreForms: "عرض المزيد من الصيغ",
    family: "عائلة الكلمة",
    usage: "كيف يستخدمها الناس فعلًا",
    traps: "أخطاء شائعة",
    examples: "أمثلة طبيعية",
    save: "احفظ في المفردات",
    saved: "محفوظة في المفردات",
    aiAssisted: "صيغ بمساعدة الذكاء الاصطناعي",
    aiAssistedHelp: "تم إنشاء هذه الصيغ والتحقق منها تلقائيًا.",
    unlock: "افتح مستكشف الكلمات مع Pro",
    unlockSub: "كل الصيغ المفيدة وعائلة الكلمة والاستخدام الحقيقي والأخطاء الشائعة والمزيد من الأمثلة.",
    unlockCta: "افتح مع Pro",
    more: "المزيد من الاستخدامات والأمثلة",
    loading: "جارٍ الاستكشاف…",
    failed: "تعذّر استكشاف هذه الكلمة. تحقّق من الإملاء.",
    back: "المفردات",
    listen: "استمع",
    alsoMeans: "أيضًا",
  },
  vocab: { markKnown: "وضع علامة كمعروفة",
    title: "بنك المفردات", subtitle: "كل كلمة تعلّمتها.", searchWords: "ابحث عن كلمات…",
    all: "الكل", known: "معروفة", learning: "قيد التعلّم", removed: "تمت الإزالة", markKnown: "وضع علامة معروفة",
    empty: "لا توجد كلمات بعد. التقط بعضها باستخدام FluentLens!",
  },
  journal: {
    title: "مذكّرة صوتية", tagline: "تحدّث عن حياتك. وتعلّم كيف تقولها.",
    speak: "تحدّث", type: "اكتب بدلاً من ذلك", recording: "جارٍ التسجيل… انقر للإيقاف",
    typePlaceholder: "اكتب بلغتك…",
    intro: "تحدّث عن يومك أو خططك أو مشاعرك، بلغتك الأم.",
    review: "راجع فكرتك", reviewHelp: "راجع النص وصحّح أي خطأ قبل الترجمة.",
    retry: "سجّل مرة أخرى", seeHowToSay: "شاهد كيف تُقال",
    whatYouSaid: "ما قلته", howToSay: "كيف تقولها بـ{lang}",
    practice: "تدرّب على قولها", practicing: "جارٍ تسجيل محاولتك…", playYours: "استمع إلى محاولتك",
    usefulWords: "كلمات مفيدة", usefulPhrases: "عبارات مفيدة", grammar: "قواعد تستحق الانتباه",
    actions: "إجراءات محتملة", saveEntry: "احفظ في المذكّرة", saved: "تم الحفظ في مذكّرتك",
    archive: "مذكّرتك", empty: "لا إدخالات بعد — تحدّث أو اكتب أول فكرة لك.",
    newEntry: "إدخال جديد", rename: "إعادة تسمية", deleted: "تم حذف الإدخال",
    micDenied: "الميكروفون غير متاح — اكتب بدلاً من ذلك.", analyzing: "نبحث عن الصياغة الطبيعية…",
    transcribing: "جارٍ الاستماع…",
  },
  friend: {
    live: {
      "premium": "Fluent Friend ميزة مميزة.",
      "voiceUnavailable": "الصوت غير متاح الآن.",
      "genericError": "حدث خطأ ما. حاول مرة أخرى.",
      "start": "ابدأ محادثة مباشرة",
      "tag": "مباشر",
      "intro": "تحدّث مباشرة باللغة التي تتعلمها. سيواصل Fluent Friend المحادثة. إذا تعثّرت، استخدم «ساعدني أن أقولها».",
      "ideas": "أفكار للبدء",
      "speak": "تحدّث",
      "stop": "إيقاف",
      "type": "اكتب باللغة التي تتعلمها…",
      "help": "ساعدني أن أقولها",
      "helpTitle": "قلها بلغتك",
      "helpPlaceholder": "قل أو اكتب ما تقصده…",
      "helpGo": "أرني كيف أقولها",
      "helped": "أردت أن تقول",
      "end": "إنهاء المحادثة",
      "voice": "صوت الصديق",
      "listening": "أستمع…",
      "understanding": "أفهم…",
      "thinking": "أفكّر…",
      "retry": "حاول مجددًا",
      "replyFailed": "تعذّر على Fluent Friend الرد الآن — رسالتك محفوظة.",
      "sttFailed": "لم نلتقط ذلك. حاول مجددًا أو اكتب.",
      "meaning": "أظهر المعنى",
      "saved": "تم حفظ المحادثة.",
      "recapTitle": "ما تدرّبت عليه",
      "keep": "تعابير تستحق الحفظ",
      "addAll": "أضف كل المفيد",
      "moreNatural": "شيء واحد لتقوله بشكل أكثر طبيعية",
      "handledWell": "شيء أتقنته",
      "practiceAgain": "يستحق التدرّب مجددًا",
      "starter": {
        "day": "حدّثني عن يومك",
        "plans": "ما الذي تخطط له؟",
        "happened": "هل حدث شيء مثير؟",
        "work": "هل نتحدث عن العمل أو الدراسة؟",
        "forward": "ما الذي تتطلع إليه؟"
      }
    },
    title: "Fluent Friend", tagline: "تحدّث عن حياتك. وتعلّم من خلال المحادثة.",
    intro: "تحدّث بتلقائية بلغتك. يساعدك Fluent Friend على قولها ب{lang} ثم يكمل المحادثة بها.",
    introText: "اكتب بتلقائية بلغتك. قل ما تريد التعبير عنه حقًا، ويساعدك Fluent Friend على قوله ب{lang} ثم يكمل المحادثة بها.",
    speak: "تحدّث", type: "اكتب", send: "إرسال", placeholder: "قل شيئًا بلغتك…",
    reviewHint: "راجع ما قلته ثم أرسله.", youCouldSay: "يمكنك أن تقول",
    showMeaning: "إظهار المعنى", hideMeaning: "إخفاء المعنى",
    recap: "ما تدرّبت عليه", newChat: "محادثة جديدة", conversations: "المحادثات",
    empty: "لا محادثات بعد — ابدأ بالحديث عن يومك.",
    startersTitle: "لا تعرف من أين تبدأ؟",
    starters: ["حدّثني عن يومك", "هل يشغل بالك شيء؟", "ماذا تخطّط؟", "هل نتحدّث عن العمل؟", "أخبرني بشيء جميل حدث", "ما الذي تتطلّع إليه؟"],
    words: "كلمات مفيدة", phrases: "عبارات مفيدة", expressions: "تعبيرات طبيعية",
    grammar: "قواعد تستحق الانتباه", practiceAgain: "يستحق التكرار",
    thinking: "Fluent Friend يردّ…", recording: "جارٍ التسجيل… انقر للإيقاف",
    micDenied: "الميكروفون غير متاح — اكتب بدلاً من ذلك.",
  },
  teacher: { dashboard: "لوحة المعلّم", myClasses: "فصولي" },
  education: {
    title: "FluentLoop للتعليم",
    pilotLine: "برنامج تجريبي مدرسي لمدة 90 يومًا — مجانًا للمدارس المُوثّقة.",
    apply: "التقديم للبرنامج التجريبي (90 يومًا)", submitting: "جارٍ الإرسال…",
  },
  assignments: {
    title: "مهامي", subtitle: "مهام كلّفك بها معلّمك.",
    empty: "لا توجد مهام حاليًا 🎉", emptySub: "عندما يكلّفك معلّمك بمهمة، ستظهر هنا.",
    doTodayLoop: "ابدأ جلسة اليوم", toDo: "للإنجاز", inProgress: "قيد التنفيذ", completed: "مكتملة",
    start: "ابدأ", continue: "متابعة", done: "تمّ", late: "(متأخّر)",
    overdue: "متأخّرة", dueToday: "مستحقّة اليوم", dueSoon: "مستحقّة قريبًا", scheduled: "مجدولة",
  },
  label: {
    gist: "الفكرة العامة", vocabulary: "المفردات", usefulPhrases: "عبارات مفيدة", grammar: "القواعد",
    verbs: "أفعال", adjectives: "صفات", idioms: "تعابير ومتلازمات", relatedWords: "كلمات ذات صلة",
    example: "مثال", naturalTranslation: "ترجمة طبيعية", whereThings: "أين توجد الأشياء",
    reanalyze: "إعادة التحليل", save: "حفظ", plural: "الجمع",
  },
  missionRun: {
    breadcrumb: "المهام", notAvailable: "هذه المهمة غير متاحة لك.",
    backToAssignments: "العودة إلى المهام", complete: "اكتملت المهمة!",
    completeDesc: "أنهيت {title}.",
    myAssignments: "مهامي", dashboard: "لوحة التحكم", yourClass: "صفّك",
    stepOf: "الخطوة {current} من {total}", optional: "اختياري",
    back: "رجوع", nextStep: "الخطوة التالية", continueBonus: "المتابعة إلى الإضافي",
    completeMission: "إكمال المهمة", finishEarly: "انتهيت — أكمل المهمة",
    keepWords: "هل تريد الاحتفاظ بهذه الكلمات لتمرينك الخاص؟", saveToBank: "احفظ في بنك مفرداتي", notNow: "ليس الآن", savedToBank: "حُفظت في بنك مفرداتك.", backToClass: "العودة إلى الصف", cantSave: "لا يمكن حفظ هذه الكلمات في بنك مفرداتك لأن لغة هذه المهمة ليست من لغات تعلّمك.", saveFailed: "تعذّر حفظ الكلمات. حاول مرة أخرى.",
  },
  lensDesc: {
    text: "ترجم المقاطع الصعبة وافهم المفردات والقواعد.",
    object: "اكتشف اسم الشيء وتعلّم اللغة من حوله.",
    scene: "انظر إلى المشهد كاملًا: صِفه، وعُدّ الأشياء، وتعلّم اللغة من حوله.",
    study: "حوّل قراءة العالم الحقيقي إلى تدريبات على الفهم.",
    archiveSub: "أعد فتح عمليات المسح السابقة، وراجع المفردات، وأعد جلسات الدراسة.",
    hintText: "وجّه نحو كتاب أو لافتة أو قائمة طعام أو رسالة", hintObject: "وجّه نحو شيء أو نبات أو حيوان",
    hintScene: "وجّه نحو وجبة أو طاولة أو غرفة أو منظر طبيعي", captureHelp: "التقط صورة أو ارفع واحدة.",
    subText: "امسح نصًّا لترجمته أو شرحه أو دراسته.",
    subObject: "وجّه نحو شيء لتتعلّم اسمه واللغة من حوله.",
    subScene: "انظر إلى المشهد كاملًا. تعلّم اللغة من حوله.",
    subStudy: "امسح نصًّا وتدرّب على فهمه.",
    captureSub: "التقط أو ارفع صورة لأي شيء لتتعلّم كلمته.",
  },
  todayHelp: {
    refresh: "جدّد ما بدأ يتلاشى", score: "قيّم نطقك",
    snap: "صوّر شيئًا واحدًا", proFeature: "ميزة Pro", proScoring: "تقييم النطق ميزة Pro",
  },
  capture: {
    title: "ماذا حولك؟", reading: "نقرأ العالم…",
    pointHint: "وجّه نحو كوب أو شجرة أو كلب…", anything: "أي شيء ينفع.",
    learnMe: "تعلّمني", savedToBank: "تم الحفظ في بنكك", shareCard: "بطاقة للمشاركة",
    building: "جارٍ الإنشاء…", capReached: "لقد وصلت إلى حدّ التقاطاتك اليومية المجانية.",
    keepStreak: "حافظ على سلسلتك!", signUpFree: "سجّل مجانًا", close: "إغلاق",
    couldNotRead: "تعذّرت قراءة هذه الصورة. جرّب صورة أخرى.",
  },
  review: {
    title: "المراجعة", tagline: "تذكّر ما يهمّ.",
    progress: "{n} من {total}",
    dueCount: { zero: "لا توجد كلمات جاهزة للمراجعة.", one: "كلمة واحدة جاهزة للمراجعة.", two: "كلمتان جاهزتان للمراجعة.", few: "{count} كلمات جاهزة للمراجعة.", many: "{count} كلمةً جاهزة للمراجعة.", other: "{count} كلمة جاهزة للمراجعة." },
    recentCount: { zero: "لا توجد كلمات حديثة.", one: "تدرّب على كلمة حديثة واحدة.", two: "تدرّب على كلمتين حديثتين.", few: "تدرّب على {count} كلمات حديثة.", many: "تدرّب على {count} كلمةً حديثة.", other: "تدرّب على {count} كلمة حديثة." },
    allDue: "كل المستحقّ", all: "الكل", start: { zero: "ابدأ", one: "ابدأ · بطاقة واحدة", two: "ابدأ · بطاقتان", few: "ابدأ · {count} بطاقات", many: "ابدأ · {count} بطاقةً", other: "ابدأ · {count} بطاقة" },
    caughtUp: "أنت على اطّلاع بكل شيء.", nothingDue: "لا شيء يحتاج إلى مراجعة الآن.", practiceRecent: "تدرّب على الكلمات الحديثة",
    reveal: "إظهار", again: "مرة أخرى", gotIt: "عرفتها", listen: "استمع",
    type: { recognition: "ماذا تعني؟", recall: "كيف تقولها؟", context: "أيّ كلمة تناسب؟", listening: "استمع — ما هي؟", typed: "اكتبها من الذاكرة" },
    typed: { label: "اكتب إجابتك", placeholder: "اكتبها ب{lang}", check: "تحقّق", correct: "صحيح", notQuite: "ليس تمامًا", yourAnswer: "إجابتك", answer: "الإجابة", showAnswer: "أظهر الإجابة", suggestAgain: "تستحق نظرة أخرى — «مرة أخرى» تعيدها أسرع.", checkFailed: "تعذّر التحقق — حاول مرة أخرى." },
    complete: "اكتملت المراجعة", reviewed: "تمت مراجعتها", remembered: "تذكّرتها", anotherLook: "تحتاج نظرة أخرى",
    nextIn: { zero: "المراجعة التالية اليوم.", one: "المراجعة التالية بعد يوم واحد.", two: "المراجعة التالية بعد يومين.", few: "المراجعة التالية بعد {count} أيام.", many: "المراجعة التالية بعد {count} يومًا.", other: "المراجعة التالية بعد {count} يوم." },
    done: "تم", backToday: "العودة إلى اليوم", todayLink: { zero: "تذكّر", one: "تذكّر · كلمة واحدة مستحقّة", two: "تذكّر · كلمتان مستحقّتان", few: "تذكّر · {count} كلمات مستحقّة", many: "تذكّر · {count} كلمةً مستحقّة", other: "تذكّر · {count} كلمة مستحقّة" },
    voiceUnavailable: "الصوت غير متاح الآن.", saveFailed: "تعذّر الحفظ — حاول مرة أخرى.",
  },
  lc: {
    "title": "دقائقك الخمس",
    "subtitle": "مصمَّمة مما تتعلّمه الآن",
    "cold": "سيصبح مسارك اليومي أكثر خصوصية كلما تعرّف FluentLoop على ما يهمّك.",
    "forYou": "لك اليوم",
    "assigned": "مُسنَد",
    "reason": {
      "due": "يعود في الوقت المناسب",
      "weak": "يستحق التذكّر",
      "activation": "رأيته لكنك لم تستخدمه بعد",
      "relevant": "محفوظ مؤخرًا",
      "recently_saved": "محفوظ مؤخرًا",
      "stretch": "خطوة أبعد",
      "function_gap": "مهارة مفيدة للتدرّب",
      "skill": "مهارة مفيدة للتدرّب"
    },
    "kind": {
      "recall": "تذكّر",
      "retrieve": "تذكّر",
      "use_it": "استخدمه",
      "situation": "موقف"
    },
    "howSay": "كيف تقول هذا؟",
    "write": "اكتب إجابتك…",
    "check": "تحقّق",
    "skip": "تخطٍّ",
    "notUseful": "غير مفيد لي",
    "next": "التالي",
    "natural": "بصيغة طبيعية",
    "tip": "نصيحة",
    "alreadyNatural": "جملتك طبيعية بالفعل.",
    "example": "مثال",
    "saved": "محفوظ",
    "useItTpl": "استخدم «{word}» في جملة واحدة.",
    "useItTopicTpl": "استخدم «{word}» في جملة عن {topic}.",
    "situationTpl": "{function}: اكتب جملة أو جملتين عن {topic}.",
    "doneTitle": "هذا يكفي لليوم.",
    "recalled": "{count} تذكّرت",
    "used": "{count} استخدمت",
    "situations": "{count} موقف تدرّبت عليه",
    "keepGoing": "تابع",
    "reviewAll": "راجع كل الكلمات المستحقة ({count})",
    "sayAloud": "قل جملة بصوت عالٍ",
    "snapWord": "صوّر كلمة جديدة",
    "alsoToday": "أيضًا اليوم",
    "progress": "{n} من {total}",
    "loading": "نُحضّر دقائقك الخمس…",
    "fn": {
      "asking_question": "طرح سؤال",
      "requesting": "طلب شيء",
      "explaining_problem": "شرح مشكلة",
      "describing": "وصف شيء",
      "narrating_past": "سرد ما حدث",
      "making_plans": "وضع خطط",
      "apologizing": "الاعتذار",
      "agreeing_disagreeing": "الموافقة أو الاعتراض",
      "expressing_preference": "التعبير عمّا تفضّله",
      "giving_opinion": "إبداء رأيك",
      "clarifying": "التوضيح",
      "small_talk": "دردشة خفيفة"
    },
    "topic": {
      "home": "المنزل",
      "work": "العمل",
      "study": "الدراسة",
      "food": "الطعام",
      "travel": "السفر",
      "transport": "التنقّل",
      "shopping": "التسوّق",
      "social_life": "الأصدقاء والخطط",
      "health_everyday": "العافية اليومية",
      "money_everyday": "المصاريف اليومية",
      "hobbies": "الهوايات",
      "culture": "الثقافة",
      "nature": "الطبيعة",
      "technology": "التكنولوجيا",
      "everyday_life": "الحياة اليومية"
    }
  },
  errors: {
    generic: "حدث خطأ ما. يُرجى المحاولة مرة أخرى.",
    couldNotSave: "تعذّر الحفظ. حاول مرة أخرى.",
  },
};
ar.pm = pm;
ar.lvl = lvl;
ar.iv = iv;
ar.vm = vm;
ar.edu = edu;
ar.lib = lib;
ar.al = al;
export default ar;
